import useSWR, { SWRConfiguration, SWRResponse } from 'swr'

type TUseSwrFetchProps = {
  url: string
  method?: string
  headers?: HeadersInit | undefined
  body?: any
  swrOptions?: SWRConfiguration
}

type TUseSwrFetchResults<TData = any, TError = any> = SWRResponse<TData, TError>

const defaultSwrOptions: SWRConfiguration = {
  revalidateOnFocus: false,
}

const useSwrFetch = <TData = any, TError = any>({
  url,
  method = 'get',
  headers,
  body,
  swrOptions = defaultSwrOptions,
}: TUseSwrFetchProps) => {
  const results = useSWR<TData, TError>(
    url,
    async (url: string) => {
      const response = await fetch(url, { method, headers, body })
      const text = await response.text()

      try {
        const json = JSON.parse(text)

        if (response.status >= 200 && response.status <= 299) return json
        else throw json
      } catch {
        throw text
      }
    },
    swrOptions
  )

  return results
}

export { useSwrFetch }
export type { TUseSwrFetchProps, TUseSwrFetchResults }
